import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {
  Card,
  Button,
  CardActionArea,
  CardHeader,
  DialogTitle,
  Avatar,
  Stack,
  Typography,
  DialogActions,
  CircularProgress,
} from '@mui/material';
import RocketRoundedIcon from '@mui/icons-material/RocketRounded';
import { useSelector } from 'react-redux';
import { useMutation, useQuery } from '@apollo/client';
import { toast } from 'react-toastify';
import graph from './graph';
import { isEmptyObject } from 'helpers/formatObject';
import { digitsEnToFa } from '@persian-tools/persian-tools';

export default function ChangePaymentStatus({ title, model, refetch }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { userToken } = useSelector((state) => state.auth);

  const {
    id,
    call_me,
    fast_send,
    total_cost,
    created_at,
    demand_time,
    delivery_time,
    tracking_code,
    shop,
    status,
    customer,
    shipping,
    payment_type,
    payment_status,
  } = model;

  const [formUpdate, {loading}] = useMutation(graph.changeFastSend.query, {
    context: {
      serviceName: graph.changeFastSend.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const handleChange = async () => {
    try {
      const { data } = await formUpdate({
        variables: {
          ids: id,
          fast_send: fast_send ? 0 : 1,
        },
      });
      if (data) {
        const res = data[graph.changeFastSend.name];
        res.messages.map((message) => toast.success(String(message)));
        refetch();
        handleClose();
      }
    } catch (error) {}
  };

  return (
    <>
      <Button
        size="small"
        color="error"
        onClick={handleOpen}
        sx={{ bgcolor: 'error.lighter', color: 'error.dark', minWidth: 96 }}
      >
      {title}
      </Button>
      <Dialog
        dir="rtl"
        fullWidth
        open={open}
        maxWidth="xs"
        // PaperComponent={Box}
        onClose={handleClose}
        // PaperProps={{
        //   sx: {
        //     minHeight: '30%',
        //   },
        // }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle sx={{ px: 1 }} component="div">
          <Typography variant="subtitle1">{fast_send ? 'ارسال سریع لغو شود؟' : 'ارسال سریع انجام شود؟'}</Typography>
        </DialogTitle>
        <DialogActions sx={{ p: 2 }}>
          <Button color="inherit" onClick={handleClose}>
            فعلا نه
          </Button>
          <Button
            color={fast_send ? 'error' : 'secondary'}
            variant="contained"
            disabled={loading}
            onClick={handleChange}
            sx={{ minWidth: 80 }}
            autoFocus
          >
            {loading ? <CircularProgress color="inherit" size={24} /> : 'بله'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
